import { ColumnInfo, ColumnInfoList, DisplaySetting } from 'components/shared/display_setting'
import { TableCell } from 'components/shared/widget'
import { StandardUrine, StandardUrineSearchForm } from 'entities/standard_urine'
import { ReactNode, useMemo } from 'react'
import { Form } from 'utils/hooks'
import { StandardUrineViewModel } from 'view_models/standard_urine_view_model'
// import { StandardUrineViewModel } from 'view_models/standard_urine_view_model'

export const standardUrineColumnInfoList = (form?: Form<StandardUrineSearchForm>): ColumnInfoList => {
    const values: ColumnInfo[] = [
        { name: 'ID', th: true, width: 40, align: 'center', form: form, orderAttr: 'standard_urine_id', searchType: { name: 'id', type: 'multiple_text' } },
        { name: '登録日', th: true, width: 200, align: 'center', form: form, orderAttr: 'standard_urine_id', searchType: { name: 'id', type: 'multiple_text' } },
        { name: '更新日', th: true, width: 200, align: 'center', form: form, orderAttr: 'standard_urine_id', searchType: { name: 'id', type: 'multiple_text' } },
        { name: 'lot', th: true, width: 200, align: 'center', form: form, orderAttr: 'standard_urine_id', searchType: { name: 'id', type: 'multiple_text' } },
        { name: 'date', th: true, width: 200, align: 'center', form: form, orderAttr: 'standard_urine_id', searchType: { name: 'id', type: 'multiple_text' } },
        { name: 'note', th: true, width: 200, align: 'center', form: form, orderAttr: 'standard_urine_id', searchType: { name: 'id', type: 'multiple_text' } },
    ]

    return {
        tableName: '',
        values: values,
    }
}

export type StandardUrineTableDataProps = {
    standardUrine?: StandardUrine
    displaySetting: DisplaySetting
}

export const StandardUrineTableData = ({ standardUrine, displaySetting }: StandardUrineTableDataProps): JSX.Element => {
    if (!standardUrine) {
        return (
            <>
                {displaySetting.columnInfoList.values.map((_: ColumnInfo, index: number) => {
                    if (displaySetting.hiddenList.includes(index)) {
                        return <></>
                    } else {
                        return <TableCell key={index}></TableCell>
                    }
                })}
            </>
        )
    }
    // const vm = new StandardUrineViewModel(standardUrine)
    const vm = new StandardUrineViewModel(standardUrine)
    const createCells = useMemo(() => {
        
        return (
            <>
                <TableCell align="center">{standardUrine.id}</TableCell>
                <TableCell align="center">{vm.createDate()}</TableCell>
                <TableCell align="center">{vm.updateDate()}</TableCell>
                <TableCell align="center">{standardUrine.lot}</TableCell>
                <TableCell align="center">{vm.date()}</TableCell>
                <TableCell align="center">{standardUrine.note}</TableCell>
            </>
        )
    }, [displaySetting.hiddenList])

    return createCells.props.children.filter((_: ReactNode, index: number) => !displaySetting.hiddenList?.includes(index)).map((cell: ReactNode) => cell)
}
